import {useEffect, useState} from 'react';
import {ORIENTATION_LOCK_MEDIA_QUERY} from '../../constants/visuals';
import {checkIfOrientationLockActive} from '../../utils/device/checkIfOrientationLockActive';

// Через сколько после последнего события перепроверить ориентацию еще раз.
// Порядок событий при повороте у браузеров разный, и на iOS значения внутри
// обработчика бывают еще старыми: screen.orientation отстает от
// orientationchange, а во встроенных браузерах размеры окна — от resize
const SETTLE_RECHECK_DELAY_MS = 500;

const WINDOW_EVENTS = ['resize', 'orientationchange', 'pageshow'];

/**
 * Показывать ли оверлей «поверните устройство»: телефон действительно
 * повернут боком (см. checkIfOrientationLockActive).
 *
 * @returns {boolean}
 */
export const useOrientationLock = () => {
  const [isOrientationLockActive, setIsOrientationLockActive] = useState(checkIfOrientationLockActive);

  useEffect(() => {
    let settleTimeoutId;
    const syncNow = () => setIsOrientationLockActive(checkIfOrientationLockActive());
    const sync = () => {
      syncNow();
      clearTimeout(settleTimeoutId);
      settleTimeoutId = setTimeout(syncNow, SETTLE_RECHECK_DELAY_MS);
    };

    const mediaQuery = window.matchMedia(ORIENTATION_LOCK_MEDIA_QUERY);
    const screenOrientation = window.screen?.orientation;

    // Ни одному событию в одиночку верить нельзя, поэтому слушаем все, что
    // сопровождает поворот, а ответ каждый раз считаем заново: setState с тем
    // же значением ре-рендер не вызывает
    mediaQuery.addEventListener?.('change', sync);
    screenOrientation?.addEventListener?.('change', sync);
    WINDOW_EVENTS.forEach((eventName) => window.addEventListener(eventName, sync));
    // Поворот, случившийся в фоне, события смены ориентации странице не шлет
    document.addEventListener('visibilitychange', sync);
    // Между первым рендером и эффектом устройство могли повернуть
    syncNow();

    return () => {
      mediaQuery.removeEventListener?.('change', sync);
      screenOrientation?.removeEventListener?.('change', sync);
      WINDOW_EVENTS.forEach((eventName) => window.removeEventListener(eventName, sync));
      document.removeEventListener('visibilitychange', sync);
      clearTimeout(settleTimeoutId);
    };
  }, []);

  return isOrientationLockActive;
};
